import { render, staticRenderFns } from "./ArticleComplete.vue?vue&type=template&id=5de34506&"
import script from "./ArticleComplete.vue?vue&type=script&lang=js&"
export * from "./ArticleComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports